import { render, staticRenderFns } from "./OrderStatusButtons.vue?vue&type=template&id=49713aa4&scoped=true"
import script from "./OrderStatusButtons.vue?vue&type=script&lang=js"
export * from "./OrderStatusButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49713aa4",
  null
  
)

export default component.exports